import { PRODUCTS } from '@bb/shared';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { productPath } from '@/lib/routes';

export const Route = createFileRoute('/app/welcome')({
  component: WelcomePage,
});

function WelcomePage() {
  const { user } = Route.useRouteContext();
  const { t } = useTranslation(['common', 'account']);
  const product = PRODUCTS[user.signupProduct];
  return (
    <div className="max-w-lg py-12">
      <h1 className="text-2xl font-semibold">
        {t('common:app.name')} · {t(`common:products.${product.id}.name`)}
      </h1>
      <p className="mt-2 text-neutral-600">{t(`common:products.${product.id}.tagline`)}</p>
      <div className="mt-8 flex gap-3">
        <Link
          to={productPath(product.id)}
          className="rounded bg-neutral-900 px-4 py-2 text-sm font-medium text-white"
        >
          {t('common:actions.continue')}
        </Link>
        <Link to="/app/settings" className="rounded border border-neutral-300 px-4 py-2 text-sm">
          {t('common:nav.settings')}
        </Link>
      </div>
    </div>
  );
}
